export default __webpack_public_path__ + "static/reviews-video-grace-9cb0f11e5e726f6d63346d0d4c1f7848.png";